export enum DiagramMenuIcons {
  Workflow = 'fa-regular fa-gear',
  Event = 'fa-solid fa-scrubber',
  StepFunction = 'fa-solid fa-rectangle'
}
